import store from "@/config/vuex/store";

export default [
    {
        path: "/rh",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [           
            {
                path: "compras-analitico",
                name: "rhComprasAnaliticoRead",
                component: () => import('@/pages/RH/RhComprasAnaliticoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "compras-sintetico",
                name: "rhComprasSinteticoRead",
                component: () => import('@/pages/RH/RhComprasSinteticoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "funcionarios",
                name: "rhFuncionarioRead",
                component: () => import('@/pages/RH/RhFuncionarioRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "funcionarios/editar/:id",
                name: "rhFuncionarioUpdate",
                component: () => import('@/pages/RH/RhFuncionarioUpdate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]

